module.exports = __webpack_public_path__ + "img/horizontal_6_3_9006.eae94b85.png";